// src/app/shared/shared.module.ts
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {ModalModule} from 'ngx-bootstrap/modal';
import {BsDropdownModule} from "ngx-bootstrap/dropdown";

// Shared components
import {PropertyCardComponent} from './components/property-card/property-card-component';
import {NgbdCarouselConfigComponent} from './components/carousel/carousel-config';
import {FooterComponent} from './components/footer/footer.component';
import {NavigationComponent} from './components/navigation/navigation.component';
import {NavigationDetailsFullComponent} from './components/navigation/navigation-details-full.component';
import {ContactFormComponent} from './components/contact-form/contact-form.component';
import {ModalContentComponent} from './components/modal-content/modal-content.component';
import {RentalContactFormComponent} from "./components/rental-contact-form/rental-contact-form.component";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule,

    // Third-party UI modules
    NgbModule,
    CollapseModule.forRoot(),
    InfiniteScrollModule,
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),

    // Standalone components
    PropertyCardComponent,
    NgbdCarouselConfigComponent,
    FooterComponent,
    NavigationComponent,
    NavigationDetailsFullComponent,
    ContactFormComponent,
    RentalContactFormComponent,
    ModalContentComponent,
  ],
  exports: [
    // Third-party UI modules for use in feature modules
    NgbModule,
    CollapseModule,
    InfiniteScrollModule,
    ModalModule,
    BsDropdownModule,

    // Shared standalone components
    PropertyCardComponent,
    NgbdCarouselConfigComponent,
    FooterComponent,
    NavigationComponent,
    NavigationDetailsFullComponent,
    ContactFormComponent,
    RentalContactFormComponent,
    ModalContentComponent,
  ]
})
export class SharedModule {
}
